<template>
  <div class="row content-box full-height">
    <woot-wizard
      class="hide-for-small-only medium-3 columns"
      :global-config="globalConfig"
      :items="items"
    />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import router from '../../../index';

export default {
  mixins: [globalConfigMixin],
  data() {
    return {
      channelSelected: '',
    };
  },
  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
    }),
    getCurrentURL() {
      return window.location.href;
    },
    items() {
      const showWhatsappBusinessFlow = this.getCurrentURL.includes(
        'new/evolution_api'
      );
      let wizard = 'INBOX_MGMT.CREATE_FLOW';
      if (
        (this.channelSelected === '' && showWhatsappBusinessFlow) ||
        this.channelSelected === 'evolution_api'
      ) {
        wizard = 'INBOX_MGMT.ADD.EVOLUTION_API.CREATE_FLOW';
      }
      return this.$t(wizard).map(item => ({
        ...item,
        body: this.useInstallationName(
          item.body,
          this.globalConfig.installationName
        ),
      }));
    },
  },
  mounted() {
    bus.$on(BUS_EVENTS.CREATE_CHANNEL_FLOW, channel => {
      this.channelSelected = channel;
    });

    // Si esta en una ruta de creación de un canal
    const isCreatingChannel = this.getCurrentURL.includes('/inboxes/new');
    // Si se esta asignando agentes en la creacion del canal
    const isAddingAgents =
      isCreatingChannel && this.getCurrentURL.includes('/agents');
    // Si se terminó de crear el canal
    const isFinished =
      isCreatingChannel && this.getCurrentURL.includes('/finish');
    // Si esta en una ruta de creación de un canal con proveedor Evolution API
    const showWhatsappBusinessFlow = this.getCurrentURL.includes(
      'new/evolution_api'
    );
    // Nombre de la ruta para redirigir en caso de estar creando un canal que no se con el proveedor Evolution API.
    const redirectToSettingsInbox = 'settings_inboxes_page_channel';
    // Expresión regular para obtener el nombre del canal a partir de la URL.
    const regex = /([^\/#?&%]+)(?:[#?&%].*)?$/;
    // Obtiene el nombre del canal a partir de la URL.
    const channel = window.location.href.match(regex)[1];
    /**
     * Si se actualizó la página (F5):
     *   - se está en una ruta de creación de un canal 
     *   - el canal que se está creando no es con el proveedor Evolution API
     *   - no se esta en la ruta de redireccion
     *   - no se esta en la ruta de agregar agentes
     *   - no se esta en la ruta final de creación
     * */
    if (
      isCreatingChannel &&
      !showWhatsappBusinessFlow &&
      this.$route.name !== redirectToSettingsInbox &&
      channel !== 'new' &&
      !isAddingAgents &&
      !isFinished
    ) {
      const params = {
        sub_page: channel,
      };
      router.replace({ name: redirectToSettingsInbox, params });
    }
  },
};
</script>
